<template>
  <!-- Desktop -->
  <div v-if="!isMobile" class="flex flex-1 h-10 items-center">
    <div class="flex h-full pr-3 py-1 items-center">
      <ORawIcon
        icon="neler-oluyor-game"
        class="rounded-[42px] text-white hover:bg-[#343640] mr-2"
        :class="tab === 'game' && 'activeTab'"
        @click.native="handleClick('game')"
      />
      <ORawIcon
        icon="neler-oluyor-news"
        class="rounded-[42px] text-white hover:bg-[#343640]"
        :class="tab === 'news' && 'activeTab'"
        @click.native="handleClick('news')"
      />
    </div>
    <div class="border-r h-3/4" style="border-color: rgba(255, 255, 255, 0.25)"></div>
    <HeaderDailyGames v-if="tab === 'game'" :games="games" @onMouseEnter="onMouseEnter" @onMouseLeave="onMouseLeave" />
    <div
      v-if="tab === 'news'"
      class="pl-1 justify-start items-center gap-2.5 inline-flex"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <div class="ml-3 font-black text-lg newsTextShadow leading-14 text-[#D9D9D9] w-[77px]">NELER OLUYOR?</div>
      <div class="w-1 h-1 bg-[#e94b4d] rounded-full"></div>
      <OLink
        v-if="article"
        :href="getArticleUrl({ article })"
        class="text-white text-sm font-normal leading-[15px] line-clamp-1 hover:text-o-red"
      >
        {{ article.title }}
      </OLink>
    </div>
  </div>
  <!-- Mobile -->
  <HeaderMobileContent v-else :games="games" :articles="news" />
</template>

<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, useContext } from '@nuxtjs/composition-api';
import HeaderDailyGames from './HeaderDailyGames.vue';
import HeaderMobileContent from './HeaderMobileContent.vue';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { useDevice } from '~/composables/useDevice';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { OLink, OImage, ORawIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { ORawIcon, OImage, HeaderDailyGames, HeaderMobileContent, OLink },
  setup() {
    const tabs = ['game', 'news'];
    const randomIndex = ref();
    const tab = ref();
    const news = ref([]);
    const { isMobile } = useDevice();
    const { $service } = useContext();
    const isPaused = ref(false);
    const timeoutId = ref(null);
    const index = ref(-1);
    const games = ref({ bilpop: null, emojile: null });

    const article = computed(() => {
      if (index.value >= 0) return news.value[index.value % news.value.length];
    });

    const handleClick = (newTab) => {
      if (newTab === tab.value) return;
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
      switchTab(newTab);
    };

    const switchTab = (newTab, nextNew = true) => {
      tab.value = newTab;
      if (isPaused.value) return;
      if (tab.value === 'game') {
        timeoutId.value = setTimeout(() => switchTab('news'), 10000);
      } else if (tab.value === 'news') {
        if (nextNew) {
          index.value = index.value + 1;
        }
        timeoutId.value = setTimeout(() => switchTab('game'), 5000);
      }
    };

    const onMouseEnter = () => {
      isPaused.value = true;
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
    };

    const onMouseLeave = () => {
      isPaused.value = false;
      switchTab(tab.value, false);
    };

    onMounted(async () => {
      randomIndex.value = Math.round(Math.random());
      tab.value = tabs[randomIndex.value];

      const [breakingNewsLocalStore, dailyBilpopLocalStore, dailyEmojileLocalStore] = await Promise.all([
        localStore.getItem('o-breaking-news'),
        localStore.getItem('o-daily-bilpop'),
        localStore.getItem('o-daily-emojile'),
      ]);

      if (breakingNewsLocalStore) {
        news.value = breakingNewsLocalStore;
      } else {
        try {
          const { data: result } = await $service.article.getBreakingNews();
          news.value = result;
          localStore.setItem('o-breaking-news', result, { expireMs: 60 }); // 1 mins
        } catch {
          news.value = [];
        }
      }

      if (dailyBilpopLocalStore) {
        games.value.bilpop = dailyBilpopLocalStore;
      } else {
        try {
          const { data } = await $service.game.getDailyQuestion({ gameType: 'bilpop' });
          games.value.bilpop = data;
          localStore.setItem('o-daily-bilpop', data, { expireMs: 60 }); // 1 mins
        } catch {
          games.value.bilpop = [];
        }
      }

      if (dailyEmojileLocalStore) {
        games.value.emojile = dailyEmojileLocalStore;
      } else {
        try {
          const { data } = await $service.game.getDailyQuestion({ gameType: 'emojile' });
          games.value.emojile = data;
          localStore.setItem('o-daily-emojile', data, { expireMs: 60 }); // 1 mins
        } catch {
          games.value.emojile = [];
        }
      }
      switchTab(tab.value);
    });

    onUnmounted(() => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
    });

    return {
      tab,
      handleClick,
      isMobile,
      onMouseEnter,
      onMouseLeave,
      article,
      getArticleUrl,
      games,
      news,
    };
  },
});
</script>

<style scoped>
.activeTab {
  background: linear-gradient(166deg, #fae439 -6.27%, #ffba08 106.87%), #797ca1;
  color: #232323 !important;
}

.newsTextShadow {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
